import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from "react";
import Close from "@engineering/icons/close";
import { IconButton } from "../IconButton";
import { Wrapper, Headline, Content, InfoIcon, TipIcon, ErrorIcon, SuccessIcon } from "./Message.styles";
import { MessageRole, MessageSeverity } from "./Message.types";
var defaultProps = {
    severity: MessageSeverity.INFO,
    role: MessageRole.STATUS
};
var _obj;
var icons = (_obj = {}, _define_property(_obj, MessageSeverity.TIP, TipIcon), _define_property(_obj, MessageSeverity.INFO, InfoIcon), _define_property(_obj, MessageSeverity.ERROR, ErrorIcon), _define_property(_obj, MessageSeverity.SUCCESS, SuccessIcon), _obj);
var Message = function(param) {
    var children = param.children, headline = param.headline, hasCloseButton = param.hasCloseButton, severity = param.severity, role = param.role;
    var ref = useState(true), visible = ref[0], setVisible = ref[1];
    var handleClose = function() {
        setVisible(false);
    };
    var Icon = icons[severity];
    return /*#__PURE__*/ _jsxs(Wrapper, {
        role: role,
        "aria-live": role === MessageRole.STATUS ? "polite" : undefined,
        severity: severity,
        visible: visible,
        children: [
            /*#__PURE__*/ _jsx(Icon, {}),
            /*#__PURE__*/ _jsxs(Content, {
                children: [
                    headline && /*#__PURE__*/ _jsx(Headline, {
                        children: headline
                    }),
                    children
                ]
            }),
            hasCloseButton && /*#__PURE__*/ _jsx(IconButton, {
                icon: Close,
                title: "close" // @TODO: Add translation
                ,
                onClick: handleClose
            })
        ]
    });
};
Message.defaultProps = defaultProps;
export { Message };
